import { z } from 'zod'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v1/pagination'

export const vocusMobileServerSchema = z.object({
    api_client_id: z.string(),
    api_client_secret: z.string(),
    auth_client_id: z.string(),
    auth_client_secret: z.string(),
    created_at: z.coerce.date().transform((date) => {
        dayjs.extend(localizedFormat)
        dayjs.extend(relativeTime)

        return dayjs(date)
    }),
    database_driver: z.string(),
    database_host: z.string(),
    database_name: z.string(),
    database_password: z.string(),
    database_port: z.number(),
    database_username: z.string(),
    deleted_at: z.coerce
        .date()
        .transform((date) => {
            dayjs.extend(localizedFormat)
            dayjs.extend(relativeTime)

            return dayjs(date)
        })
        .nullable(),
    description: z.string(),
    name: z.string(),
    plan_id: z.string(),
    proxy_host: z.string(),
    proxy_port: z.number(),
    title: z.string(),
    updated_at: z.coerce.date().transform((date) => {
        dayjs.extend(localizedFormat)
        dayjs.extend(relativeTime)

        return dayjs(date)
    }),
    uuid: z.string().uuid(),
    wsm_access_key: z.string(),
    wsm_cert_pass: z.string(),
    wsm_cert_path: z.string(),
})

export const vocusMobileServersSchema = z.array(vocusMobileServerSchema)

export const paginatedVocusMobileServersSchema = z.object({
    data: vocusMobileServersSchema,
    links: paginationLinksSchema,
    meta: paginationMetaSchema,
})

export type VocusMobileServer = z.infer<typeof vocusMobileServerSchema>
export type VocusMobileServers = z.infer<typeof vocusMobileServersSchema>
